import styled from "styled-components";

const Li = styled.li`
  font-size: 14px;
  line-height: 1.14;
  color: #222939;
  list-style: none;
  margin-bottom: 8px;
  width: 100%;
  padding: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  :hover {
    background-color: #f4f5f8;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
  }

  /* focus */
  &[tabindex="0"] {
    background-color: #f4f5f8;
    width: 100%;
    border-radius: 4px;
    outline: none;
  }

  :focus {
    outline: none;
  }
`;

export { Li };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/header/autocomplete/ItemStyle.js